import React, { useState } from "react";
import { Card, Form, Button, Row, Col, Alert } from "react-bootstrap";
import axios from "axios";

const AddNews = () => {

    const [formData, setFormData] = useState({
        writer: "",
        title: "",
        category: "",
        shortDesc: "",
        content: "",
        status: "Published",
        image: null,

        videoUrl: "",
        adTitle: "",
        adImage: null,
        adLink: ""
    });

    const [preview, setPreview] = useState(null);
    const [adPreview, setAdPreview] = useState(null);
    const [validated, setValidated] = useState(false);
    const [success, setSuccess] = useState(false);

    // ✅ ADD: format youtube URL
    const formatVideoUrl = (url) => {
        if (!url) return "";
        return url.replace("watch?v=", "embed/");
    };

    // ================= HANDLE CHANGE =================
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "image") {
            const file = files && files[0];
            setFormData({ ...formData, image: file });

            if (file) {
                setPreview(URL.createObjectURL(file));
            }
        }

        else if (name === "adImage") {
            const file = files && files[0];
            setFormData({ ...formData, adImage: file });

            if (file) {
                setAdPreview(URL.createObjectURL(file));
            }
        }

        else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // ================= SUBMIT =================
    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }

        try {
            const data = new FormData();

            data.append("writer", formData.writer);
            data.append("title", formData.title);
            data.append("category", formData.category);
            data.append("shortDesc", formData.shortDesc);
            data.append("content", formData.content);
            data.append("status", formData.status);

            data.append("videoUrl", formData.videoUrl);
            data.append("adTitle", formData.adTitle);
            data.append("adLink", formData.adLink);

            if (formData.image) {
                data.append("image", formData.image);
            }

            if (formData.adImage) {
                data.append("adImage", formData.adImage);
            }

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/news`,
                data,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            // ✅ ADD: Debug Cloudinary response
            console.log("API RESPONSE:", response.data);

            if (response.data.success) {
                setSuccess(true);

                setFormData({
                    writer: "",
                    title: "",
                    category: "",
                    shortDesc: "",
                    content: "",
                    status: "Published",
                    image: null,
                    videoUrl: "",
                    adTitle: "",
                    adImage: null,
                    adLink: ""
                });

                setPreview(null);
                setAdPreview(null);
                setValidated(false);
            }

        } catch (error) {
            console.error("Error adding news:", error);
        }
    };

    return (
        <Card className="p-4 shadow border-0">
            <h4 className="mb-4 fw-bold">Add New Article</h4>

            {success && (
                <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
                    News article published successfully!
                </Alert>
            )}

            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="g-3">

                    {/* TITLE */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>News Title</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="Enter news title"
                            />
                        </Form.Group>
                    </Col>

                    {/* CATEGORY */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Category</Form.Label>
                            <Form.Select
                                required
                                name="category"
                                value={formData.category}
                                onChange={handleChange}
                            >
                                <option value="">Select Category</option>
                                <option>Politics</option>
                                <option>Business</option>
                                <option>Technology</option>
                                <option>Sports</option>
                                <option>Entertainment</option>
                                <option>Health</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    {/* SHORT DESC */}
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label>Short Description</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="shortDesc"
                                value={formData.shortDesc}
                                onChange={handleChange}
                                placeholder="Enter short description"
                            />
                        </Form.Group>
                    </Col>

                    {/* CONTENT */}
                    <Col md={12}>
                        <Form.Group>
                            <Form.Label>Full Content</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                required
                                name="content"
                                value={formData.content}
                                onChange={handleChange}
                                placeholder="Write full article content..."
                            />
                        </Form.Group>
                    </Col>

                    {/* WRITER */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Writer Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="writer"
                                value={formData.writer}
                                onChange={handleChange}
                                placeholder="Enter writer name"
                            />
                        </Form.Group>
                    </Col>

                    {/* IMAGE */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Upload Image</Form.Label>
                            <Form.Control
                                type="file"
                                name="image"
                                accept="image/*"   // ✅ FIX
                                onChange={handleChange}
                            />
                        </Form.Group>

                        {preview && (
                            <div className="mt-2">
                                <img
                                    src={preview}
                                    alt="preview"
                                    style={{ width: "120px", height: "80px", objectFit: "cover" }}
                                />
                            </div>
                        )}
                    </Col>

                    {/* VIDEO */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Video URL</Form.Label>
                            <Form.Control
                                type="text"
                                name="videoUrl"
                                value={formData.videoUrl}
                                onChange={handleChange}
                                placeholder="https://www.youtube.com/watch?v=xyz"
                            />
                        </Form.Group>
                    </Col>

                    {/* VIDEO PREVIEW */}
                    {formData.videoUrl && (
                        <Col md={6}>
                            <iframe
                                width="100%"
                                height="200"
                                src={formatVideoUrl(formData.videoUrl)} // ✅ FIX
                                title="Video Preview"
                                allowFullScreen
                            />
                        </Col>
                    )}

                    {/* ADS SECTION */}
                    <Col md={12}>
                        <hr />
                        <h5 className="fw-bold">Advertisement</h5>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Ad Title</Form.Label>
                            <Form.Control
                                type="text"
                                name="adTitle"
                                value={formData.adTitle}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                    {/* AD IMAGE */}
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Ad Image Upload</Form.Label>
                            <Form.Control
                                type="file"
                                name="adImage"
                                accept="image/*"   // ✅ FIX
                                onChange={handleChange}
                            />
                        </Form.Group>

                        {adPreview && (
                            <div className="mt-2">
                                <img
                                    src={adPreview}
                                    alt="ad preview"
                                    style={{ width: "120px", height: "80px", objectFit: "cover" }}
                                />
                            </div>
                        )}
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Ad Link</Form.Label>
                            <Form.Control
                                type="text"
                                name="adLink"
                                value={formData.adLink}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Col>

                    {/* STATUS */}
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value="Published">Published</option>
                                <option value="Draft">Draft</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    {/* BUTTON */}
                    <Col md={12} className="text-end">
                        <Button type="submit" variant="danger" className="px-4">
                            Publish Article
                        </Button>
                    </Col>

                </Row>
            </Form>
        </Card>
    );
};

export default AddNews;